import { importProvidersFrom } from '@angular/core';
import { LoadingBarModule } from '@ngx-loading-bar/core';
import { LoadingBarHttpClientModule } from '@ngx-loading-bar/http-client';

export const provideLoadingBar = importProvidersFrom(LoadingBarModule, LoadingBarHttpClientModule);
